/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_filter_min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const es_f1_apex_filter_min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mín`)
};

const de_f1_apex_filter_min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const nl_f1_apex_filter_min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const fr_f1_apex_filter_min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const it_f1_apex_filter_min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

const pt_br2_f1_apex_filter_min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mín`)
};

const pt_f1_apex_filter_min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mín`)
};

const ja_f1_apex_filter_min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小`)
};

const zh_f1_apex_filter_min = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_filter_min = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_filter_min(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_filter_min", locale)
	if (locale === "en") return en_f1_apex_filter_min(inputs)
	if (locale === "es") return es_f1_apex_filter_min(inputs)
	if (locale === "de") return de_f1_apex_filter_min(inputs)
	if (locale === "nl") return nl_f1_apex_filter_min(inputs)
	if (locale === "fr") return fr_f1_apex_filter_min(inputs)
	if (locale === "it") return it_f1_apex_filter_min(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_filter_min(inputs)
	if (locale === "pt") return pt_f1_apex_filter_min(inputs)
	if (locale === "ja") return ja_f1_apex_filter_min(inputs)
	return zh_f1_apex_filter_min(inputs)
};